<template>
  <div class="about">
    <h1 class="page-header">How to Donate</h1>
    <how-to-can v-if="$store.state.country == 'can'" />
    <how-to-us v-if="$store.state.country == 'us'" />
  </div>
</template>
<script>
import HowToUs from "./HowToUs";
import HowToCan from "./HowToCan";
export default {
  name: "Howtodonate",
  metaInfo: {
    title: "How to donate",
  },
  components: {
    HowToUs,
    HowToCan,
  },
};
</script>